import BaseSetup from '@/components/BaseSetup';
import useBusService from '@/services/BusService';
import useDocumentService from '@/services/DocumentService';
import { DOCUMENT_TYPE } from '@/typings/enums/DOCUMENT_TYPE';
import { TAG_LINK_TYPE } from '@/typings/enums/TAG_LINK_TYPE';
import { Reactive } from '@/utils/decorators';

type TimeTicket = {
	timeTicketId: number
	timeTicket: { tagLinks: ITagLinkModel[] }
};

export type SharedListDocumentActionsEmits = {};
export type SharedListDocumentActionsProps = {
	tagOpened?: boolean
	selected?: { id: number, tagLinks?: ITagLinkModel[] }[]
	tag?: Function
	documentType: DOCUMENT_TYPE
	linkType?: TAG_LINK_TYPE
};

export default class SharedListDocumentActionsSetup extends BaseSetup {

	static readonly defaultProps = {
		selected: () => [],
		tag: () => {},
		linkType: undefined,
	};

	@Reactive private readonly state = { tags: [] };
	readonly documentService: ReturnType<typeof useDocumentService>;

	private get inTimeTicketContext () { return this.props.linkType === TAG_LINK_TYPE.TimeTicket }

	constructor (
		private props: SharedListDocumentActionsProps,
		private emits: SharedListDocumentActionsEmits,
	) {
		super();
		this.documentService = useDocumentService(this.self.userType, this.props.documentType);
	}

	mappedValue () {
		if (this.inTimeTicketContext) {
			return new Map((this.props.selected as unknown as TimeTicket[]).map(x => [
				x.timeTicketId,
				x.timeTicket.tagLinks.map(x => ({
					id: x.id,
					tagId: x.tagId,
				})),
			]));
		}
		else {
			return new Map(this.props.selected?.map(x => [
				x.id,
				x.tagLinks?.map(x => ({
					id: x.id,
					tagId: x.tagId,
				})) ?? [],
			]));
		}
	}

	handleTagAdd (payload: ITagLinkModel[]) {
		if (this.inTimeTicketContext) {
			payload.forEach((tag) => {
				(this.props.selected as unknown as TimeTicket[])
					.find(x => x.timeTicketId === tag.linkId)?.timeTicket.tagLinks.push(tag);
				useBusService().emit(`timeticketListItem:addTag:${this.props.linkType}${tag.linkId}`, tag);
			});
		}
		else {
			payload.forEach((tag) => {
				this.props.selected
					?.find(x => x.id === tag.linkId)
					?.tagLinks
					?.push(tag);
				useBusService().emit(`documentListItem:addTag:${this.props.linkType}${tag.linkId}`, tag);
			});
		}
	}

	handleTagDelete ([tagLinkIds]: [number[]]) {
		if (this.inTimeTicketContext) {
			(this.props.selected as unknown as TimeTicket[]).forEach((x) => {
				x.timeTicket.tagLinks.deleteWhere(tl => tagLinkIds.includes(tl.id));
				useBusService().emit(`timeticketListItem:deleteTag:${this.props.linkType}${x.timeTicketId}`, tagLinkIds);
			});
		}
		else {
			this.props.selected?.forEach((x) => {
				x.tagLinks?.deleteWhere(tl => tagLinkIds.includes(tl.id));
				useBusService().emit(`documentListItem:deleteTag:${this.props.linkType}${x.id}`, tagLinkIds);
			});
		}
	}

}
